// Three-surface UI alignment pass (three-surface-ui-alignment): restyled
// onto Genesis tokens; data layer (getAccount query) untouched.
import { useQuery } from '@tanstack/react-query'
import { useParams } from '@tanstack/react-router'
import { getAccount } from '@/lib/grpcweb/console-api'
import { GREY_300, GREY_400, GREY_500, WHITE, errorBlockStyle } from '@/lib/genesis'

export function AccountDetailPage() {
  const { accountId } = useParams({ from: '/accounts/$accountId' })
  const { data, isLoading, isError } = useQuery({
    queryKey: ['accounts', accountId],
    queryFn: () => getAccount(accountId),
  })

  if (isLoading) return <p className="text-sm" style={{ color: GREY_400 }}>Loading…</p>
  if (isError || !data) {
    return (
      <div className="px-3 py-2" style={errorBlockStyle}>
        <p className="text-sm" style={{ color: WHITE }}>Could not load account {accountId}.</p>
      </div>
    )
  }

  const acct = data.getAccount()
  if (!acct) return <p className="text-sm" style={{ color: GREY_400 }}>Account not found.</p>

  return (
    <div>
      <h1 className="font-display mb-1 text-xl font-semibold" style={{ color: WHITE }}>{acct.getName()}</h1>
      <p className="mb-6 font-mono text-xs" style={{ color: GREY_500 }}>{acct.getId()}</p>

      <h2 className="mb-2 text-sm font-medium" style={{ color: GREY_300 }}>
        Partner attribution (ADR-118 D12)
      </h2>
      <dl className="glass-card grid grid-cols-2 gap-x-8 gap-y-3 p-5 text-sm md:grid-cols-3">
        <div>
          <dt className="font-mono" style={{ color: GREY_400 }}>partner_id</dt>
          <dd style={{ color: GREY_300 }}>{acct.getPartnerId() || '—'}</dd>
        </div>
        <div>
          <dt className="font-mono" style={{ color: GREY_400 }}>deal_registration_id</dt>
          <dd style={{ color: GREY_300 }}>{acct.getDealRegistrationId() || '—'}</dd>
        </div>
        <div>
          <dt className="font-mono" style={{ color: GREY_400 }}>identity_provider</dt>
          <dd style={{ color: GREY_300 }}>{acct.getIdentityProvider() || 'local'}</dd>
        </div>
      </dl>
    </div>
  )
}
